import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TPublicAttachmentStore, TPublicAttachmentUploadInfo } from './types';

const getPublicAttachmentState = (state: TStoreState): TPublicAttachmentStore =>
	state.publicAttachment;

export const getPublicAttachment = getPublicAttachmentState;

export const getPublicAttachmentUploadInfo = createSelector(
	[getPublicAttachment],
	(publicAttachment: TPublicAttachmentStore): TPublicAttachmentUploadInfo | null =>
		publicAttachment.uploadInfo,
);

export const getPublicAttachmentUploadInfoLoading = createSelector(
	[getPublicAttachment],
	(publicAttachment: TPublicAttachmentStore): boolean => publicAttachment.uploadInfoLoading,
);

export const getPublicAttachmentUploadInfoError = createSelector(
	[getPublicAttachment],
	(publicAttachment: TPublicAttachmentStore): string | null => publicAttachment.uploadInfoError,
);

export const getPublicAttachmentUploadFileLoading = createSelector(
	[getPublicAttachment],
	(publicAttachment: TPublicAttachmentStore): boolean => publicAttachment.uploadFileLoading,
);

export const getPublicAttachmentUploadSuccess = createSelector(
	[getPublicAttachment],
	(publicAttachment: TPublicAttachmentStore): boolean => publicAttachment.uploadSuccess,
);
